// extracted by mini-css-extract-plugin
export default {"movieDetailPage":"MovieDetailPage_movieDetailPage__06Ct1"};